<app-block *ngFor="let block of blocks" [type]="type" [block]="block" [blocksCount]="blocks.length">
</app-block>